import React from 'react';
import {Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Input from 'reactstrap/es/Input';
import ItemOption from '../Widget/ItemOption';
import BaseComponent from '../BaseComponent';
import {statusColor} from '../../utils/Utilities';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import ModalCardHeader from "../Widget/ModalCardHeader";

/*= (message, okCallback, cancelCallback) =>*/
export default class UpdateAssemblyStatusModal extends BaseComponent{

    constructor(props){
        super(props);
        let {modal, assembly, okCallback, closeCallback} = this.props
        let state = this.state
        state.modal = modal
        state.backdrop = false
        state.assembly = assembly
        state.assemblyStatuses = []
        state.newAssemblyStatus = {}
        state.okCallback = okCallback
        state.closeCallback = closeCallback
        state.message = ""
        this.setState(state)
    }

    componentWillReceiveProps(props, nextContext) {
        let {modal, assembly, okCallback, closeCallback} = props
        if(props.modal && !this.props.modal){
            this.setState({
                modal:modal,
                assembly: assembly,
                okCallback : okCallback,
                closeCallback : closeCallback,
                newAssemblyStatus:{},
                message:"",
            }, () => {
                this.fetchAssemblyStatuses()
            })
        }
    }

    fetchAssemblyStatuses = () =>{
        let {assembly} = this.state
        if(!assembly){
            assembly = {}
        }
        let assemblyStatus = assembly.assemblyStatus?assembly.assemblyStatus:{}
        let params = {params:{assemblyId:assembly.id}}
        if(assemblyStatus.id){
            this.get(Endpoint.API.ASSEMBLY_STATUSES_ADMIN_SELECTION, params, null, response=>{
                if(response.code===200){
                    let assemblyStatuses = response.data
                    let assemblyStatusOptions = []
                    assemblyStatuses.map((item, index)=>{
                        assemblyStatusOptions.push(item)
                    })
                    this.setState({
                        assemblyStatuses : assemblyStatusOptions
                    })
                }
            }, true, true)
        }
    }


    updateAssemblyStatus=()=>{
        let {assembly, newAssemblyStatus, message} = this.state
        if(!assembly){
            assembly = {}
        }
        let assemblyStatus = assembly.assemblyStatus?assembly.assemblyStatus:{}
        if(!newAssemblyStatus){
            return
        }
        let confirmationMessage = "";
        confirmationMessage= "Do you want to update this assembly status from = "+assemblyStatus.name+" to = "+newAssemblyStatus.name+" ? "
        this.openConfirmDialog(label.Confirmation, confirmationMessage, ()=>{
            let formData = new FormData();
            formData.append("assemblyId", assembly.id)
            formData.append("assemblyStatusId", newAssemblyStatus.id)
            formData.append("message", message)
            this.post(Endpoint.API.OVERRIDE_ASSEMBLY_STATUS, formData, null, response=>{
                if(response.code===200){
                    let assembly = response.data
                    this.successToast(response.message)
                    this.setState({
                        modal:false
                    }, () => {
                        if(this.state.okCallback){
                            this.state.okCallback(assembly)
                        }
                    })
                }
            }, true, true)
        })
    }

    render(){
        let {assembly, newAssemblyStatus, assemblyStatuses, message} = this.state
        if(!assembly){
            assembly = {}
        }
        let assemblyStatus = assembly.assemblyStatus?assembly.assemblyStatus:{}
        if(!assemblyStatuses){
            assemblyStatuses = []
        }
        if(!newAssemblyStatus){
            newAssemblyStatus = {}
        }
        return (
            <Modal size="lg" centered={true}
                isOpen={this.state.modal}
                backdrop={true}>
                {super.render()}
                <ModalCardHeader content={(
                    <span>Update Assembly Status</span>
                )}/>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="currentStatus">Current Status</Label>
                                <Input
                                    style={{fontSize:'bold', color:statusColor(assemblyStatus.id), borderColor: statusColor(assemblyStatus.id)}}
                                    id="currentStatus"
                                    type="text"
                                    name="currentStatus"
                                    value={assemblyStatus.name}
                                    readOnly
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <ItemOption
                                    title={label.SelectStatus}
                                    objects={assemblyStatuses}
                                    default={newAssemblyStatus.id}
                                    callback={(newAssemblyStatus)=>{
                                        if(newAssemblyStatus!=null){
                                            this.setState({
                                                newAssemblyStatus:newAssemblyStatus
                                            })
                                        }else{
                                            this.setState({
                                                newAssemblyStatus:{}
                                            })
                                        }
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col>
                            <FormGroup>
                            <Label for="message">{label.Message}</Label>
                            <Input
                                id="message"
                                type="textarea"
                                name="message"
                                value={message}
                                style={{minHeight:'100px'}}
                                onChange={(e) =>{
                                    let value = e.target.value
                                    this.setState({
                                        message : value?value:null
                                    })
                                }}
                                placeholder={label.EnterMessageForThisUpdate_Recommended}
                            />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        {
                            newAssemblyStatus.id&&(
                                <Col>
                                    <Button color="primary" onClick={e=>{
                                        this.updateAssemblyStatus()
                                    }}>
                                        Update
                                    </Button>
                                </Col>
                            )
                        }
                        <Col>
                            <Button color="secondary" onClick={e=>{
                                e.preventDefault()
                                this.setState({
                                    modal:false
                                })
                                if(this.state.closeCallback){
                                    this.state.closeCallback()
                                }
                            }}>
                                {label.Cancel}
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        )
    }
}

UpdateAssemblyStatusModal.propTypes = {
    modal:PropTypes.bool,
    assembly:PropTypes.object,
    okCallback:PropTypes.func,
    closeCallback:PropTypes.func,
}
